// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7e20c5f0","453":"6a3440c5","806":"d31031c9"}[chunkId] + ".chunk.js";
};